import { Users, AlertTriangle, GripVertical } from "lucide-react";

function UnassignedList({ stats, list, filter }) {
  if (stats.unassigned.length === 0) {
    return <p data-testid="coverage-ok" className="text-xs text-emerald-700 font-semibold">Tutti i nominativi della lista base sono assegnati.</p>;
  }
  if (list.length === 0) {
    return <p data-testid="unassigned-no-match" className="text-xs text-slate-500 italic">Nessun risultato per "{filter}".</p>;
  }
  return (
    <div>
      {list.map((p) => (
        <div key={p} data-testid={`unassigned-${p}`}
          draggable
          onDragStart={(e) => e.dataTransfer.setData("application/x-person", JSON.stringify({ person: p, fromSite: null }))}
          title="Trascina su un cantiere per assegnare"
          className="text-sm text-slate-800 px-2 py-1 border-b border-slate-200 cursor-grab active:cursor-grabbing hover:bg-slate-200 transition-colors flex items-center gap-1.5">
          <GripVertical className="w-3 h-3 text-slate-400 shrink-0" />{p}</div>
      ))}
    </div>
  );
}

export default function UnassignedPanel({ stats, filter = "" }) {
  const q = filter.trim().toLowerCase();
  const list = q ? stats.unassigned.filter((p) => p.toLowerCase().includes(q)) : stats.unassigned;
  return (
    <aside data-testid="unassigned-panel"
      className="print-hide border-t lg:border-t-0 lg:border-l border-slate-300 bg-slate-50 w-full lg:w-72 p-4 shrink-0 overflow-y-auto lg:min-h-[calc(100vh-7rem)]">
      <div className="flex items-center gap-2 mb-3">
        <Users className="w-4 h-4 text-slate-600" />
        <h3 className="text-sm font-bold uppercase tracking-tight text-slate-800">Non assegnati</h3>
        <span data-testid="unassigned-count"
          className={`ml-auto text-xs font-mono font-bold px-2 py-0.5 rounded-sm ${stats.unassigned.length ? "bg-red-100 text-red-800" : "bg-emerald-100 text-emerald-800"}`}>
          {stats.unassigned.length}
        </span>
      </div>
      <UnassignedList stats={stats} list={list} filter={filter} />
      {stats.bis.length > 0 && (
        <div className="mt-4">
          <div className="flex items-center gap-2 mb-2">
            <AlertTriangle className="w-4 h-4 text-orange-600" />
            <h3 className="text-sm font-bold uppercase tracking-tight text-orange-700">Duplicati BIS</h3>
          </div>
          {stats.bis.map((p) => (
            <div key={p} data-testid={`bis-list-${p}`}
              className="text-sm px-2 py-1 border-b border-orange-100 text-orange-800 bg-orange-50">{p}</div>
          ))}
        </div>
      )}
    </aside>
  );
}
